export default __webpack_public_path__ + "static/header-emote-2a2dc4c509a6d99ccb41e9e220b0663e.png";